var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.template_id,"title":"PDF","size":"lg","hide-footer":""}},[(_vm.view)?_c('div',[_c('vue-pdf-app',{attrs:{"pdf":_vm.pdf}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }